"use strict";

// App shell (layout change, supersedes UX spec §3.1). Vanilla JS.
//
//   * Sidebar: expandable sections (saved per user), menus (New DM, user),
//     new-project dialog, mobile drawer.
//   * Counts: the global bell and per-project dots come from
//     /notifications.json (so the bell always equals the sum of the dots);
//     the project header's counts (one per lifecycle state, plus All tasks)
//     from <project>/shell.json. Both refresh on realtime events.
//   * Right panel: one panel at a time, beside the main pane. Views (Needs
//     you, one per lifecycle state, All tasks) and detail (task, unplanned)
//     load server-rendered fragments. All tasks filters client-side. Opening detail
//     from a view stacks it, with a back arrow. Close with X or Esc.
//   * Forms marked [data-ajax] (and card/panel forms) post with fetch, then
//     reload with the panel reopened, so every count shows derived truth.

(function () {
  var shellEl = document.getElementById('shell');
  if (!shellEl || !document.body.classList.contains('has-shell')) return;

  var meta = document.querySelector('meta[name="csrf-token"]');
  var csrf = meta ? meta.getAttribute('content') : null;
  var panel = document.getElementById('panel');
  var thread = document.querySelector('.thread[data-thread-mode="home"]');
  var pageBase = thread ? thread.getAttribute('data-base') : null;
  var actions = document.querySelector('[data-project-actions]');
  if (!pageBase && actions) pageBase = actions.getAttribute('data-counts-url').replace(/\/shell\.json$/, '');

  function stash(k, v) { try { sessionStorage.setItem(k, v); } catch (_e) {} }
  function take(k) { try { var v = sessionStorage.getItem(k); sessionStorage.removeItem(k); return v; } catch (_e) { return null; } }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json', 'X-CSRF-Token': csrf },
      body: body.toString()
    });
  }

  // ── Toast (after an action reloads the page) ──────────────────────────────
  var toast = take('rw:toast');
  if (toast) {
    var t = document.createElement('p');
    t.className = 'sh-toast'; t.setAttribute('role', 'status'); t.textContent = toast;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 5000);
  }

  // ── Sidebar sections (saved per user) ─────────────────────────────────────
  document.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-sb-toggle]');
    if (!tog) return;
    var sec = tog.closest('[data-sb-sec]');
    var body = sec && sec.querySelector('.sb-sec__body');
    if (!body) return;
    var open = body.hidden;
    body.hidden = !open;
    sec.classList.toggle('is-open', open);
    tog.setAttribute('aria-expanded', open ? 'true' : 'false');
    var p = new URLSearchParams();
    p.set(tog.getAttribute('data-sb-toggle'), open ? 'true' : 'false');
    post('/me/ui-prefs', p).catch(function () {});
  });

  // ── Popup menus (New DM, user) ────────────────────────────────────────────
  function closeMenus(except) {
    document.querySelectorAll('[data-sb-menu]').forEach(function (m) {
      if (m === except) return;
      m.hidden = true;
      var b = m.parentNode.querySelector('[data-sb-menu-btn]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-menu-btn]');
    if (btn) {
      e.stopPropagation();
      var menu = btn.parentNode.querySelector('[data-sb-menu]');
      var open = menu.hidden;
      closeMenus(menu);
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var first = menu.querySelector('a, button'); if (first) first.focus(); }
      return;
    }
    if (!e.target.closest('[data-sb-menu]')) closeMenus();
  });

  // ── New-project dialog (the "+" beside each org) ──────────────────────────
  var dlg = document.getElementById('newProjectDialog');
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-new-project]');
    if (add && dlg && typeof dlg.showModal === 'function') {
      e.preventDefault();
      var form = dlg.querySelector('[data-new-project-form]');
      form.action = '/org/' + add.getAttribute('data-new-project') + '/projects';
      dlg.querySelector('[data-new-project-org]').textContent = 'In ' + add.getAttribute('data-org-name');
      form.reset();
      dlg.showModal();
      return;
    }
    if (e.target.closest('[data-dialog-close]')) { var d = e.target.closest('dialog'); if (d) d.close(); }
  });

  // ── Mobile drawer ─────────────────────────────────────────────────────────
  var scrim = document.getElementById('shellScrim');
  function drawer(open) {
    shellEl.classList.toggle('shell--drawer', open);
    if (scrim) scrim.hidden = !open;
    var b = document.querySelector('[data-shell-drawer]');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-shell-drawer]')) { drawer(!shellEl.classList.contains('shell--drawer')); return; }
    if (e.target.closest('[data-shell-drawer-close]')) drawer(false);
  });

  // ── Counts ────────────────────────────────────────────────────────────────
  function setCount(el, n, quietZero) {
    if (!el) return;
    el.textContent = n > 99 ? '99+' : String(n || 0);
    el.hidden = !quietZero && !n;
    el.classList.toggle('is-zero', !n);
  }
  function refreshGlobal() {
    return fetch('/notifications.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        setCount(document.getElementById('globalBellCount'), d.count || 0);
        var by = {};
        (d.items || []).forEach(function (it) { by[it.project_id] = (by[it.project_id] || 0) + 1; });
        document.querySelectorAll('[data-attn-for]').forEach(function (dot) {
          var n = by[dot.getAttribute('data-attn-for')] || 0;
          dot.hidden = !n;
          dot.textContent = n ? String(n) : '';
          dot.setAttribute('aria-label', n + ' waiting on you');
        });
      })
      .catch(function () {});
  }
  function refreshProject() {
    if (!actions) return Promise.resolve();
    return fetch(actions.getAttribute('data-counts-url'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        Object.keys(d).forEach(function (k) {
          var el = actions.querySelector('[data-count="' + k + '"]');
          setCount(el, d[k], k !== 'attention');
        });
      })
      .catch(function () {});
  }
  var countTimer = null;
  function refresh() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      refreshGlobal(); refreshProject();
      // A list view reflects the same state: reload it in place.
      if (panel && !panel.hidden && current && current.view) load(current, { replace: true, quiet: true });
    }, 400);
  }
  refreshGlobal(); refreshProject();
  window.addEventListener('rushworks:message-event', function (ev) {
    var m = ev.detail && ev.detail.message;
    if (!m || (m.kind && m.kind !== 'human')) refresh();
  });
  window.addEventListener('rushworks:activity-event', refresh);
  if (window.io) {
    var sock = window.RushworksRealtime && window.RushworksRealtime.socket;
    if (!sock) sock = window.io({ transports: ['websocket', 'polling'] });
    sock.on('notification:event', refresh);
  }

  window.RushworksShell = { refresh: refresh };
  window.RushworksInbox = { refresh: refresh }; // older callers

  if (!panel) return;

  // ── Right panel ───────────────────────────────────────────────────────────
  var stack = [];      // entries: { view?, kind?, id?, url, base? }
  var current = null;
  var lastFocus = null;

  function detailUrl(kind, id, base) {
    var b = base || pageBase;
    if (!b) return null;
    if (kind === 'task') return b + '/tasks/' + encodeURIComponent(id) + '?panel=1';
    if (kind === 'unplanned') return b + '/unplanned?panel=1&key=' + encodeURIComponent(id);
    return null;
  }
  function markButtons() {
    document.querySelectorAll('[data-panel-view]').forEach(function (b) {
      var on = !!(current && current.view && b.getAttribute('data-panel-url') === current.url);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function hashFor(entry) {
    if (entry.view) return entry.global ? '#panel=attention-all' : '#panel=' + entry.view;
    return '#' + entry.kind + '=' + encodeURIComponent(entry.id);
  }
  function addBack() {
    if (stack.length < 2) return;
    var top = panel.querySelector('.panel__top');
    if (!top || top.querySelector('[data-panel-back]')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'panel__back'; b.setAttribute('data-panel-back', '');
    b.setAttribute('aria-label', 'Back'); b.textContent = '←';
    top.insertBefore(b, top.firstChild);
  }
  function load(entry, opts) {
    opts = opts || {};
    if (!opts.quiet) panel.innerHTML = '<div class="panel__inner"><p class="panel__hint">Loading...</p></div>';
    return fetch(entry.url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        panel.innerHTML = html;
        addBack();
        initFilters(panel);
        if (!opts.quiet) {
          var focusEl = panel.querySelector('[data-panel-back], [data-panel-close]');
          if (focusEl) focusEl.focus();
        }
        history.replaceState(null, '', location.pathname + location.search + hashFor(entry));
      })
      .catch(function () {
        panel.innerHTML = '<div class="panel__inner"><div class="panel__top"><p class="panel__hint">Could not load this. It may have been removed.</p>'
          + '<button class="panel__close" data-panel-close type="button" aria-label="Close">×</button></div></div>';
        addBack();
      });
  }
  function show(entry, push) {
    if (panel.hidden) lastFocus = document.activeElement;
    if (push) stack.push(entry); else stack = [entry];
    current = entry;
    panel.hidden = false;
    shellEl.classList.add('shell--panel');
    markButtons();
    return load(entry);
  }
  function openView(btn) {
    var url = btn.getAttribute('data-panel-url');
    // Toggling the open view's button closes the panel.
    if (!panel.hidden && current && current.view && current.url === url && stack.length === 1) { closePanel(); return; }
    show({ view: btn.getAttribute('data-panel-view'), url: url, global: btn.id === 'globalBell' }, false);
  }
  function openDetail(kind, id, base) {
    var url = detailUrl(kind, id, base);
    if (!url) return false;
    // From a list view, detail stacks (back arrow); otherwise it replaces.
    var push = !panel.hidden && !!current;
    show({ kind: kind, id: id, url: url, base: base }, push);
    return true;
  }
  function back() {
    if (stack.length < 2) return closePanel();
    stack.pop();
    current = stack[stack.length - 1];
    markButtons();
    load(current);
  }
  function closePanel() {
    panel.hidden = true; panel.innerHTML = '';
    shellEl.classList.remove('shell--panel');
    stack = []; current = null;
    markButtons();
    history.replaceState(null, '', location.pathname + location.search);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    var v = e.target.closest('[data-panel-view]');
    if (v) { e.preventDefault(); drawer(false); openView(v); return; }
    if (e.target.closest('[data-panel-close]')) { e.preventDefault(); closePanel(); return; }
    if (e.target.closest('[data-panel-back]')) { e.preventDefault(); back(); return; }
    var tr = e.target.closest('[data-task-ref]');
    if (tr && openDetail('task', tr.getAttribute('data-task-ref'), tr.getAttribute('data-task-base'))) { e.preventDefault(); return; }
    var tg = e.target.closest('[data-tag-ref]');
    if (tg && openTasksWithTag(tg.getAttribute('data-tag-ref'))) { e.preventDefault(); return; }
    var ur = e.target.closest('[data-unplanned-ref]');
    if (ur && openDetail('unplanned', ur.getAttribute('data-unplanned-ref'))) { e.preventDefault(); return; }
    var mr = e.target.closest('[data-message-ref]');
    if (mr) {
      var el = document.getElementById('m-' + mr.getAttribute('data-message-ref'));
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.classList.add('chat__msg--flash'); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.querySelector('dialog[open]')) return;
    if (shellEl.classList.contains('shell--drawer')) { drawer(false); return; }
    var openMenu = document.querySelector('[data-sb-menu]:not([hidden])');
    if (openMenu) { closeMenus(); return; }
    if (!panel.hidden) closePanel();
  });

  // A tag chip (or an old goal link, ?tag=<id>) opens All tasks filtered to it.
  function openTasksWithTag(id) {
    var btn = document.querySelector('[data-project-actions] [data-panel-view="tasks"]');
    if (!btn) return false;
    saveFilters({ tags: [String(id)], states: [], origin: '', type: '', done: false, q: '' });
    if (!panel.hidden && current && current.view === 'tasks') { applyFilters(panel, true); return true; }
    show({ view: 'tasks', url: btn.getAttribute('data-panel-url'), global: false }, false);
    return true;
  }

  // Reopen from the hash (#task=12, #panel=in_staging) or after an action reload.
  function fromHash(h) {
    var m = /^#(task|unplanned)=(.+)$/.exec(h || '');
    if (m) return { kind: m[1], id: decodeURIComponent(m[2]) };
    var v = /^#panel=([a-z_-]+)$/.exec(h || '');
    if (v) {
      var sel = v[1] === 'attention-all' ? '#globalBell' : '[data-project-actions] [data-panel-view="' + v[1] + '"]';
      return { button: document.querySelector(sel) };
    }
    return null;
  }
  var reopen = fromHash(take('rw:reopen') || location.hash);
  if (!reopen && panel.getAttribute('data-open-kind')) {
    reopen = { kind: panel.getAttribute('data-open-kind'), id: panel.getAttribute('data-open-id') };
  }
  var tagParam = new URLSearchParams(location.search).get('tag');
  if (!reopen && tagParam) openTasksWithTag(tagParam);
  else if (reopen && reopen.button) openView(reopen.button);
  else if (reopen && reopen.kind) openDetail(reopen.kind, reopen.id);

  // ── AJAX forms (panel + cards) ────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax], .tc form')) return;
    var msg = form.getAttribute('data-confirm');
    if (msg && !window.confirm(msg)) { e.preventDefault(); return; }
    e.preventDefault();
    var body = new URLSearchParams(new FormData(form));
    if (e.submitter && e.submitter.name) body.set(e.submitter.name, e.submitter.value);
    var btns = form.querySelectorAll('button');
    btns.forEach(function (b) { b.disabled = true; });
    post(form.action, body)
      .then(function (r) { return r.json().catch(function () { return { ok: r.ok, error: 'HTTP ' + r.status }; }); })
      .then(function (d) {
        if (!d || d.ok === false) throw new Error((d && d.error) || 'That did not work');
        if (!panel.hidden && current) stash('rw:reopen', hashFor(stack[0] && stack[0].view ? stack[0] : current));
        stash('rw:toast', d.message || (d.task_id ? ('Done. Task #' + d.task_id + '.') : 'Done.'));
        location.reload();
      })
      .catch(function (err) {
        btns.forEach(function (b) { b.disabled = false; });
        var note = form.querySelector('.form-error') || document.createElement('p');
        note.className = 'panel__hint form-error';
        note.textContent = err.message;
        form.appendChild(note);
      });
  });

  // ── All tasks: filters (client-side, over the server-rendered list) ───────
  // Tag chips (multi-select, AND), state chips (any of), origin, type, Show
  // done, text search. Kept per project for this tab, so an action's reload
  // comes back to the same filtered list.
  var FKEY = 'rw:tf:' + (pageBase || '');
  function loadFilters() {
    try { return JSON.parse(sessionStorage.getItem(FKEY)) || null; } catch (_e) { return null; }
  }
  function saveFilters(f) { try { sessionStorage.setItem(FKEY, JSON.stringify(f)); } catch (_e) {} }
  function readFilters(root) {
    var f = { tags: [], states: [], origin: '', type: '', done: false, q: '' };
    root.querySelectorAll('[data-tf-tag][aria-pressed="true"]').forEach(function (b) { f.tags.push(b.getAttribute('data-tf-tag')); });
    root.querySelectorAll('[data-tf-state][aria-pressed="true"]').forEach(function (b) { f.states.push(b.getAttribute('data-tf-state')); });
    var o = root.querySelector('[data-tf-origin]'); if (o) f.origin = o.value;
    var t = root.querySelector('[data-tf-type]'); if (t) f.type = t.value;
    var d = root.querySelector('[data-tf-done]'); if (d) f.done = d.checked;
    var q = root.querySelector('[data-tf-search]'); if (q) f.q = q.value.trim().toLowerCase();
    return f;
  }
  function writeFilters(root, f) {
    root.querySelectorAll('[data-tf-tag]').forEach(function (b) {
      b.setAttribute('aria-pressed', f.tags.indexOf(b.getAttribute('data-tf-tag')) >= 0 ? 'true' : 'false');
    });
    root.querySelectorAll('[data-tf-state]').forEach(function (b) {
      b.setAttribute('aria-pressed', f.states.indexOf(b.getAttribute('data-tf-state')) >= 0 ? 'true' : 'false');
    });
    var o = root.querySelector('[data-tf-origin]'); if (o) o.value = f.origin || '';
    var t = root.querySelector('[data-tf-type]'); if (t) t.value = f.type || '';
    var d = root.querySelector('[data-tf-done]'); if (d) d.checked = !!f.done;
    var q = root.querySelector('[data-tf-search]'); if (q) q.value = f.q || '';
  }
  function applyFilters(root, fromStore) {
    var box = root.querySelector('[data-task-filters]');
    if (!box) return;
    var f = fromStore ? (loadFilters() || readFilters(box)) : readFilters(box);
    if (fromStore) writeFilters(box, f);
    // Picking the Done state chip implies showing Done.
    var showDone = f.done || f.states.indexOf('done') >= 0;
    var shown = 0;
    root.querySelectorAll('[data-tf-row]').forEach(function (li) {
      var tags = (li.getAttribute('data-tags') || '').split(',').filter(Boolean);
      var st = li.getAttribute('data-state');
      var ok = (st !== 'done' || showDone)
        && f.tags.every(function (id) { return tags.indexOf(id) >= 0; })
        && (!f.states.length || f.states.indexOf(st) >= 0)
        && (!f.origin || li.getAttribute('data-origin') === f.origin)
        && (!f.type || li.getAttribute('data-type') === f.type)
        && (!f.q || (li.getAttribute('data-text') || '').indexOf(f.q) >= 0);
      li.hidden = !ok;
      if (ok) shown++;
    });
    var c = root.querySelector('[data-tf-count]');
    if (c) c.textContent = shown + (shown === 1 ? ' task' : ' tasks');
    var empty = root.querySelector('[data-tf-empty]');
    if (empty) empty.hidden = shown > 0;
    saveFilters(f);
  }
  function initFilters(root) {
    var box = root.querySelector('[data-task-filters]');
    if (!box || box.getAttribute('data-bound')) return;
    box.setAttribute('data-bound', '1');
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-tf-tag], [data-tf-state]');
      if (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        applyFilters(root);
        return;
      }
      if (e.target.closest('[data-tf-clear]')) {
        writeFilters(box, { tags: [], states: [], origin: '', type: '', done: false, q: '' });
        applyFilters(root);
      }
    });
    box.addEventListener('change', function () { applyFilters(root); });
    box.addEventListener('input', function (e) { if (e.target.matches('[data-tf-search]')) applyFilters(root); });
    applyFilters(root, true);
  }

})();
